export const zh = {
  welcome: '欢迎',
  logout: '登出',
  trading_accounts: '交易账户',
  account_list: '账户列表',
  create_live_account: '开设真实账户',
  upgrade_to_live_account: '升级至真实账户',
  create_demo_account: '创建模拟账户',
  finance: '财务',
  deposit_funds: '入金',
  withdraw_funds: '出金',
  internal_transfer: '内部转账',
  external_transfer: '外部转账',
  transfer_back: '转账',
  transfer_back_to_my_local_depositor: '转账至当地入金账户',
  transfer_to_external_account: '转账至外部银行账户',
  payment_history: '支付历史',
  my_cards: '我的银行卡',
  my_profile: '我的信息',
  personal_information: '个人信息',
  change_password: '修改密码',
  upload_documents: '上传文件',
  partner: '合作伙伴',
  overview: '概览',
  clients: '客户',
  sub_ibs: '子代理',
  payout: '支出',
  marketing_material: '市场材料',
  withdrawal_history: '出金历史记录',
  become_a_partner: '成为合作伙伴',
  please_fill_the_following_fields: '请填写下面的内容',
  what_geographic_region: '您主要开发市场的区域是哪里？',
  submit: '提交',
  upload_documents_notice: '为了您的帐户激活并可以交易<a>请上传您的文件</a> 并完成您的个人信息',
  change_password_ta_notice: '新的交易账户将采用您的新密码。这不会影响您目前的交易账户。',
  changepass_error: '当前账户密码错误，请重新尝试。',
  changepass_success: '密码需改成功',
  current_password: '当前密码',
  new_password: '新密码',
  confirm_new_password: '确认新密码',
  pending_account: '未激活账户',
  account_must_be_approved_message: '在开设新真实账户前，您的账户需经过验证审核。',
  new_trading_account_message: '新交易账户成功激活',
  password_generated_for_ta: '新账户的密码已经生成并已发送至您的邮箱',
  new_trading_account_type_message: '新{type}账户已经生成',
  choose_your_desired_trading_platform_and_settings: '请选择合适的交易平台及相关设置',
  select_leverage: '选择杠杆',
  create: '创建',
  select_account_type: '选择账户类型',
  select_currency: '选择币种',
  no_trading_account_found: '没有交易账户',
  bankwire_notice:
    '感谢您提交银行信息，我们将与您的银行确认信息。<br><br>您将在未来24小时内收到电子邮件包含您个人支付信息。您可以使用这些信息来进行之后的入金操作。<br><br><strong>请注意:</strong> 此支付信息仅针对单一客户身份使用。如果您未来的入金不使用此支付信息，我们将不接受您的入金。任何第三方不得使用客户专用支付信息。',
  deposit: '入金',
  account_details: '账户信息',
  enter_fasapay_id: '请输入您的Fasapay账户名',
  account_id: '账户名',
  continue: '继续',
  bankwire_deposit_details_notice: ' 我们的银行要求您提供银行详细信息，以便处理您的入金。通过电汇进行的任何存款都将退还至您同一入金帐户',
  bankwire_withdrawal_details_notice: '我们的银行要求您提供银行详细信息，以便处理您的出金申请。通过电汇进行的任何出金将退还至您入金的同一帐户',
  bankwire_verify_account_notice: '<p>电汇前请确认账户信息。请 <a href="{FSROOT_URL}upload-documents">上传您的文件</a></p>',
  bankwire_amount_label: '数额 ({minDeposit} 最低. 入金)',
  bank_name: '银行名称',
  full_name: '全名',
  deposit_methods: '入金方式',
  deposit_select_ta_p: '请选择您想入金的交易账户',
  coming_soon: '即将上线',
  amount: '数额',
  proof_of_id: '身份证明',
  proof_of_id_instructions: '身份证明',
  documents_must_contain_all_of_the_following_details: '按照下列要求提供文件',
  your_full_name: '您的全名',
  a_unique_id_number: '单独身份信息号码',
  your_birthdate: '您的生日',
  your_place_of_birth: '您的出生地',
  a_visible_photo: '您的照片',
  your_signature: '您的签字',
  your_nationality: '您的国籍',
  proof_of_residence_instructions: '请上传您的银行账单或水电费账单',
  your_residential_address: '您的居住地址',
  date_of_issue: '颁发日期',
  other: '其它',
  other_documents_instructions: '其它文件需要开户部门确认',
  deposit_failed: '入金失败',
  deposit_successful: '入金成功',
  already_logged_in: '已经登入',
  login: '登入',
  create_an_account: '创建账户',
  partner_clients: '合作伙伴-客户',
  trades: '交易',
  client_id: '客户身份',
  trading_account: '交易账户',
  platform: '平台',
  order: '订单',
  pair: '对',
  volume: '交易量',
  close_date: '平仓日期',
  commission: '佣金',
  status: '状态',
  total_commission_generated: '佣金总计',
  total_deposits: '入金总计',
  total_withdrawals: '出金总计',
  date_joined: '创建日期',
  more: '更多',
  banners: '广告展示',
  partner_marketing_material: '合作伙伴-市场营销素材',
  partner_overview: '合作伙伴-总览',
  partner_payout: '合作伙伴-支出',
  partner_payout_request_message: '您的需求已经收到',
  select_your_default_payment_option: '选择您默认支付方式',
  beneficiary_name_on_account: '收款人（账户持有人）',
  bank_address: '银行地址',
  sorty_code_if_applicable: 'Sort Code银行代码',
  your_provider_email: '您的{provider} 电子邮件',
  select: '选择',
  next: '下一步',
  please_confirm_your_bank_details: '请确认您的银行信息',
  bank: '银行',
  sub_partners: '子代理',
  state: '展示',
  date: '日期',
  internal_transfer_instructions: '您可以在您多个交易账户之间转账<br>请输入需要转账的数额以及选择需要转至的账户。<br>内部转账是即时执行的。',
  transfer_complete: '转账完成',
  transfer_from: '转账来自',
  internal_transfer_processed_successfully: '内部转账成功',
  external_transfer_processed_successfully: '外部转账成功',
  select_account: '选择账户',
  to: '至',
  warning_currency_conversion_will_take_place: '提醒：货币转换汇率产生',
  transfer: '转账',
  account: '账户',
  currency: '货币',
  balance: '余额',
  equity: '净值',
  download: '下载',
  launch: '发布',
  email: '电子邮件',
  password: '密码',
  forgot: '遗忘',
  forgot_password: '密码遗忘',
  risk_warning_footer:
    '风险提示: 交易诸如外汇和差价合约之类的杠杆产品可能并不适合所有投资者，因为它们会对您的资本造成一定程度的风险。在交易之前，请确保考虑到您的投资目标和经验水平，充分了解所涉及的风险，并在必要时寻求独立的建议。请阅读全文 <a href="{riskURL}">风险披露</a>.',
  error_contact_support: '出现错误，请联系客服团队',
  type: '种类',
  funded: '已入金',
  username: '用户名',
  company_name: '公司名',
  website: '网站',
  first_name: '名称',
  last_name: '姓氏',
  date_of_birth: '出生日期',
  gender: '性别',
  phone: '电话',
  dial_code: '区号',
  country: '国家',
  address: '地址',
  year_moved_to_address: '此地址使用起始年份',
  post_code: '邮编',
  selected_currency: '选择货币',
  january: '1月',
  february: '2月',
  march: '3月',
  april: '4月',
  may: '5月',
  june: '6月',
  july: '7月',
  august: '8月',
  september: '9月',
  october: '10月',
  november: '11月',
  december: '12月',
  already_have_an_account: '已注册账户',
  invalid_request_login_required: '无效申请，您需要登录',
  register_accounttype_account: '注册{accountType} 账户',
  client_type: '客户类型',
  individual: '个人',
  company: '公司',
  company_information: '公司信息',
  company_website: '公司网站',
  complete_live_registration: '完成真实账户注册',
  title: '称呼',
  confirm_password: '确认密码',
  select_country: '选择国家',
  phone_number: '电话号码',
  choose_trading_platform: '选择交易平台',
  select_option: '选项',
  day: '日期',
  month: '月份',
  year: '年份',
  company_registration_information: '公司注册日期',
  date_of_registration: '注册日期',
  select_nationality: '选择国籍',
  nationality: '国籍',
  select_gender: '选择性别',
  male: '男性',
  female: '女性',
  address_line: '地址栏',
  city_town: '城市/城镇',
  state_province: '省份',
  select_year: '选择年份',
  year_moved_to_current_address: '此地址起始年份',
  company_shareholders_directors: '公司股东及董事',
  number_of_shareholders: '股东数量',
  number_of_directors: '董事数量',
  shareholder: '股东',
  financial_information: '财务信息',
  total_estimated_net_worth: '预估价值（欧元）？',
  less_than_amount: '少于 {amount}',
  over_amount: '超过 {amount}',
  total_estimated_annual_income: '预估年收入（欧元）？',
  employment_information: '职业信息',
  employment_status: '职业现状',
  employed: '工作',
  self_employed: '自由职业',
  retired: '退休',
  student: '学生',
  unemployed: '无业',
  source_of_income: '收入来源',
  employment: '工作收入',
  inheritance: '继承',
  investment: '投资',
  trading_experience: '交易经验',
  forex_cfds_and_other_instruments: '外汇，差价合约及其他产品',
  yes: '是的',
  no: '否',
  lose_capital_risk: '衍生产品适合作为我的投资目标和对风险的态度的一部分，并且我能够评估交易它们所涉及的风险，包括我可能会损失全部资本的可能性',
  prev_pro_qualifications: ' 我拥有金融服务行业的专业资格和/或工作经验',
  account_type: '账户类型',
  choose_currency: '选择货币',
  tos_with_link: '我已经阅读并了解和接受隐私条款，风险披露，以及展示的开户合约和合作伙伴合约 <a target="_blank" href="{URL}">此处</a>',
  registration_successful: '注册成功',
  reset_password_invalid_link: ' 您的重置链接无效，请重试或联系客服团队。',
  reset_account_password: '重设账户密码',
  choose_your_new_password: '选择新的密码',
  reset_password: '重设密码',
  file_upload_failed_filename: '上传文件 {filepath}失败。',
  withdrawal_request_success_message: '您的出金申请提交成功',
  withdraw: '出金',
  please_fill_the_following: '请填写下列',
  cancel: '取消',
  withdraw_select_ta_p: '请选择需要出金的交易账户',
  free_margin_change_warning: '请注意，出金应使用与您入金相同的方法进行。',
  you_need_an_ib_account_to_visit_this_page: '您需要注册成为代理方可访问此页',
  no_permission_to_to_visit_this_page: '您没有权限访问此页',
  you_became_a_partner_successfully: '恭喜您，成功成为EuroTrader合作伙伴！',
  note_wallet_currency_conversion_partner: '请注意，成为合作伙伴后，您的钱包货币将更改为USD，并且任何当前资金将以当前汇率转换为USD！',
  upgraded_to_a_live_account_successfully: '升级至真实账户成功！',
  passwords_dont_match: '密码不符',
  password_rules: ' 至少1个大写字母，1个小写字母和1个数字（最多6到16个字符）',
  please_fill: '请填写',
  partner_verify_first_notice: '您需要通过账户验证，方可成为合作伙伴。请上传您的文件 <a href="upload-documents">此处</a>',
  only_currency_format_allowed: '唯一准许货币种类',
  please_enter_your_account_id: '请输入您的账户ID',
  min_deposit_with_bankwire_is_amount: '电汇入金最低数额 {amount}',
  please_select_different_tas: '请选择不同的交易账户',
  you_need_to_accept_our_tos: '您需要同意并接受条例及条款',
  phone_is_required: '填写电话号码',
  invalid_phone_number: '电话号码无效',
  you_must_be_over_18: '您需要18岁以上',
  year_is_required: '填写年份',
  leave_page_question: '离开页面？',
  registration_exit_notice: '您未完成注册，确实要放弃离开吗？',
  internal_server_error_support: '出现错误，请联系客服团队',
  please_fill_all_fields: '请填写所有内容',
  no_logs_found_for_this_client: '无此客户信息',
  no_accounts_send: '无账户信息发送',
  internal_server_error_try_again: '出现错误，请再尝试',
  insufficient_balance: '余额不足',
  currency_conversion_connection_error: '货币转换服务无相应，请稍后再试或联系客服团队',
  currency_conversion_error: '货币转换出现错误，请稍后再试或联系客服团队',
  invalid_accounts: '无效账户',
  withdrawal_unsuccessful_equity_message: '出金不成功，交易账户净值不足。 {TAID}',
  withdrawal_failed_free_margin: '出金失败。请查看您的剩余保证金。',
  pamm_copy_server_field_message: '请将IP地址黏贴复制至MT4平台‘服务器’栏',
  invalid_request: '无效申请',
  missing_shareholders_directors: '缺少股东/董事信息',
  missing: '缺少',
  invalid_request_passwords_do_not_match: '无效申请。密码不符',
  email_exists_message: '邮件已存在，请使用其它邮件地址',
  your_payment_method_has_already_been_set: '您的支付方式已经预设。请联系客服团队',
  payment_method_is_required_message: '请提供您的支付信息。请再尝试或联系客服团队',
  couldnt_find_your_account: '无法找到您的账户',
  ta_limit_error_message: '您的交易账户已经达到限额({limit}) for {platform}.',
  error: '错误',
  account_created_successfully: '帐户创建成功',
  invalid_leverage: '无效杠杆',
  insufficient_data_provided: '提供信息无效',
  insufficient_data_provided_missing_field: '提供信息无效。缺少{field}.',
  invalid_amount: '无效账户',
  account_taid_doesnt_exist: '账户{TAID}不存在',
  withdrawal_unsuccessful_equity_taid: '出金申请不成功, 交易账户净值不足{TAID}',
  withdrawal_unsuccessful_free_margin_taid: '出金不成功, 交易账户保证金余额不足 {TAID}',
  internal_server_error: '服务器出现错误',
  deposit_failed_support: '入金不成功，请联系客服团队。',
  upload_documents_instructions: '请提供下列文件。<br>文件接受PDF, JPG 或者PNG 格式，并且不得超过5mb大小。',
  total_earned: '获利总计',
  total_paid: '支付总计',
  total_clients: '客户数量总计',
  total_sub_ibs: '子代理数量总计',
  see_trading_accounts: '查看交易账户',
  see_trades: '查看交易账户',
  welcome_title_live: '感谢您选择EuroTrader开设您的交易账户！',
  welcome_title_demo: '感谢您选择EuroTrader开设您的模拟交易账户！',
  welcome_title_ib: '感谢您选择EuroTrader开设您的合作伙伴账户！',
  welcome_text_live:
    '<p>入金前, 请激活账户方可交易。您需要完成下列步骤：</p><ul><li>登录您的Eurotrader客户专区</li><li>上传您的开户文件</li><li>将您的账户入金</li><li>开始交易!</li></ul><p>如果您有任何需要，请随时联系我们的客服团队。点击 <a href="{contactURL}" target="_blank">这里</a></p>',
  welcome_text_demo:
    '<p>入金前，请激活账户方可交易。您需要完成下列步骤：</p><ul><li>下载MT4平台</li><li>测试您的交易技巧以及检测我们交易执行速度</li><li>登录进入客户专区并升级为真实账户</li><li>上传开户文件并入金</li><li>开始进入全球最大的金融市场交易！</li></ul><p>如果您需要任何帮助，请联系我们的客服团队。联系我们，点击 <a href="{contactURL}" target="_blank">这里</a></p>',
  welcome_text_ib:
    '<p>为了开通您的合作伙伴账户并使用推荐链接，您需要完成以下步骤:</p><ul><li>登入您的客户专区</li><li>上传您的文件</li><li>查收您的介绍开户链接，链接在‘总览’以及‘市场工具’部分</li><li>推荐给您的客户并开始获得佣金！</li></ul><p>如果您需要任何帮助，请联系我们的客服团队。点击 <a href="{contactURL}" target="_blank">这里</a></p>',
  bankwire_passports_notice: '请注意：电汇入金需要您将护照作为身份验证的文件。',
  tracking_links: '跟踪链接',
  proof_of_residence: '地址证明',
  login_to_your_account: '登入<br>您的帐户',
  register: '注册',
  open_demo_account: '开设模拟账户',
  create_partner_account: '开设合作伙伴账户',
  page_title_partner: '成为合作伙伴| Eurotrader',
  ib_payout_msg_monthly_payment: ' 付款会通过您选择的方法每两个月进行一次。付款将在每月的第15个和第1个工作日进行。',
  payout_selection_complete: '支付方式已选择',
  home: '首页',
  about: '关于',
  account_types: '账户类型',
  spreads: '点差',
  funding: '入金',
  education: '教育',
  contact: '联系我们',
  forex_broker: '外汇经纪商',
  services_provided_by: 'Eurotrade Global Ltd所提供金融服务',
  footer_certificate_eurotrader:
    'Eurotrade SA（Pty）Ltd /前身是Technology Hub（Pty）Ltd（“ Eurotrader”）是Eurotrade RGB Holdings Ltd（HE367109）的子公司，是经南非金融部门行为监管局（FSCA）许可和监管的授权金融服务提供商，编号为FSP <a href="https://www.fsca.co.za/Fais/Search_FSP.htm" style="color: #e04ef8; text-decoration: underline" target="_blank">44351</a> ，注册地址为74 Walmer street, Sydenham, Johannesburg, 2192, South Africa。<br /><br /><!--“ Eurotrader”是Eurotrade Investments RGB Ltd的注册商标，这是一家塞浦路斯投资公司（CIF），注册号为HE317893，由塞浦路斯证券交易委员会（CySEC）许可并受其监管，许可号为279/15，注册地址为70, Kyrillou Loukareos Street, Kakos Premier Tower, 1st Floor, 4156 Limassol, Cyprus. 银行卡处理将由Eurotrade Investments RGB Ltd.完成。<br /><br /> -->Eurotrader does not provide services to residents of certain jurisdictions including the USA, Iran, Canada, the Democratic Republic of Korea, Belgium, Japan, and is not intended for distribution to, or use by, any person in any country or jurisdiction where such distribution or use would be contrary to local law or regulation.<br /><br />Eurotrade SA (PTY) Ltd does not actively target EU clients.',
  footer_risk_warning:
    '交易诸如外汇和差价合约之类的杠杆产品可能并不适合所有投资者，因为它们会对您的资本造成一定程度的风险。请确保在交易之前考虑到您的投资目标和经验水平，并充分了解所涉及的风险，并在必要时寻求独立的建议。请阅读完整的 <a href="{brokerURL}assets/pdf/risk-disclosure.pdf?v={urlRandomString}" style="color: #e04ef8; text-decoration: underline" target="_blank">风险披露</a>。',
  open_live_account: '开设真实账户',
  not_registered_with_question: '还没有注册EuroTrader?',
  forgot_password_q: '忘记密码？',
  pending_deposit_success: '操作成功，您的入金等待确认中',
  your_card_will_be_charged_cny: '您的银行卡将收取 <b>{amount}</b> 元人民币',
  currency_conversion_info: '货币转换信息',
  min_deposit_is_amount: '最低入金{amount}',
  min_transfer_is_amount: '最低转账{amount}',
  local_depositor: '本地入金提供商',
  converted_amount: '转换后数额',
  from_currency: '来自货币',
  to_currency: '转换货币',
  reference_id: '参考编号',
  from_account: '来自账户',
  to_account: '转至账户',
  from_date: '自日期',
  to_date: '至日期',
  target_account_id: '目标账户ID',
  wallet: '钱包',
  received: '收到',
  send: '发送',
  sender_not_a_transfer_account: '发送对方并非本地如今提供商',
  withdrawal_failed_support: '出金申请不成功，请联系客服团队。',
  clear: '清理',
  transfer_completed_successfully: '成功完成转账。',
  receive: '接受',
  view_trades: '查看交易',
  your_provider_account_number: '您的 {provider} 账户号码',
  your_bitcoin_address: '您的比特币地址',
  your_crypto_address: '您的{crypto}地址',
  destination_tag: '标的标签',
  change_trading_account_password: '更改交易账户密码',
  your_card_will_be_charged_thb: '您的银行卡将被收取 <b>{amount}</b> THB',
  dashboard: '信息汇总显示',
  sent: '发送',
  client_state_approved: '审核完成',
  client_state_pending: '等待',
  open_trades: '未平仓交易',
  trade_history: '交易历史',
  search_trades: '搜索交易',
  trade_no: '交易号码',
  symbol: '符号',
  open_price: '开仓价格',
  close_price: '平仓价格',
  datetime: '日期时间',
  my_bonuses: '我的赠金',
  bonus: '赠金',
  conversion_progress: '转换过程',
  front_of_id: '身份文件正面',
  back_of_id: '身份文件背面',
  include_account_in_bonus_program: '您想收到100%赠金吗？',
  invest_under_master_account: '主账户下投资',
  i_accept_the_terms_of_service: '我接受条例条款',
  pamm_master_locks_withdrawals: '[此Pamm主账户管理者规定有未平仓交易禁止出金！]',
  open_p_l: '未平仓盈亏统计',
  p_l: '盈亏统计',
  gains_prc: '获利百分比',
  max_drawdown: '最大回撤',
  bonus_tos_with_link: '我已经阅读并了解 <a target="_blank" href="{URL}">100%赠金条款的条例条件</a>。',
  i_am_over_18: '我确认本人超过18周岁并开设交易账户。',
  all_time: '整日',
  last_month: '前一个月',
  last_week: '前一周',
  last_3_days: '过去3天',
  monthly_avg: '每月平均',
  profit: '利润',
  create_and_attach: '创建并粘贴',
  attach: '粘贴',
  create_and_attach_new_pamm_account: '创建并粘贴新Pamm账户',
  select_a_pamm_account_to_attach: '选择一个Pamm账户并粘贴',
  enter_private_code: '输入私人代码',
  private_code: '私人代码',
  investor_link: '投资者链接',
  i_accept_the_lpoa: '我接受有限授权书',
  invest: '投资',
  view_graph: '查看图表',
  name: '名字',
  search: '搜索',
  partners: '伙伴',
  reject_withdrawls_during_open_trades: '未平仓情况下拒绝出金',
  private_master_account: '私人主账户',
  minimum_deposit: '最低入金',
  performance_fee: '业绩提成',
  display_name: '显示名称',
  new_master_account: '新主账户',
  pamm_statistics: 'Pamm数据统计',
  pamm: 'Pamm',
  volume_traded: '已交易数额',
  apply_date_range: '显示日期范围',
  pamm_master_locks_deposits: '[此Pamm主账户管理者拒绝在未平仓交易情况下出金！]',

  // new with vue
  bitcoin: '比特币',
  register_live_account: '注册真实账户',
  register_partner_account: '注册合作伙伴账户',
  register_demo_account: '注册模拟账户',
  risk_disclosure: '风险披露',
  address_line_2: '地址栏2',
  skype_id: 'Skype信息',
  password_rules_extended: ' 密码必须至少包含：1个大写字母，1个小写字母，1个数字和一个特殊字符。密码长度必须在6到16个字符之间。',
  login_information: '登录信息',
  director: '董事数量',
  pmethod_visa_mastercard: 'VISA/MASTERCARD',
  pmethod_visa_mastercard_alternative: 'VISA/MASTERCARD',
  pmethod_bitcoin: '比特币',
  pmethod_bankwire: '银行转账',
  pmethod_fasapay: 'Fasapay',
  pmethod_ideal: '理想化的',
  pmethod_instant_bank_transfer: '即时银行转账',
  pmethod_jeton: 'Jeton',
  pmethod_jeton_wallet: 'Jeton钱包',
  pmethod_my_pay: 'MyPay',
  pmethod_neteller: 'NETELLER',
  pmethod_vload: 'VLOAD',
  pmethod_paykasa: 'Paykasa',
  pmethod_skrill: 'Skrill',
  pmethod_sofort: 'Sofort',
  pmethod_koalapay: 'KoalaPay',
  pmethod_cup: '中国银联',
  pmethod_lydiax: '加密货币',
  pmethod_safecharge: 'SafeCharge',
  pmethod_trustly: '值得信赖的 - 银行电汇',
  field_min_currency_value: '此{field} 处需填写 {min}或更多 or more.',
  method_deposit: '{method} 入金',
  method_deposit_status: '{method} 入金状态',
  quick_menu: '快速菜单',
  details: '细节',
  date_from: '日期自',
  date_to: '截止日期',
  from: '自',
  forgot_password_form_instruction: '请在下面提交您帐户的电子邮件地址。然后，您将收到一封电子邮件，其中包含用于重置密码的链接。',
  forgot_password_submit_success_message: '密码重置链接将发送至您的邮箱，请登录您的邮箱 ({email})并根据链接修改您得密码。',
  password_reset_successfully: '您的密码已经成功重置',
  password_too_week_or_mismatch: '您的密码太简单或密码不符',
  withdrawals_credit_card_remaining_amount_message: '如果您选择其它方式出金，您需要首先出金{amount} 至您的信用卡。',
  withdrawals_credit_card_refund_policy_message: ' 信用卡提供商仅允许您提取存入您卡中的总金额。',
  withdrawals_amount_withdrawable_message: '共计{amount}可出金至您的银行卡，其它超出数额需要选择其它出金途径。',
  country_blocked_for_this_method: '您的国家不支持这种方式',
  copied_text_successfully: '复制{text} 成功',
  choose_wallet_currency: '选择钱包货币种类',
  pamm_master_account_created_successfully: 'Pamm主账户设置成功！',
  or_account_no_for_uk: '或者账户号码（UK客户）',
  issue_date: '发行日期',
  expiry_date: '截止日期',
  full_copy_of_the_document: ' 显示所有四个角的文档的完整副本',
  recent_date: '最近日期（不得超过3个月有效期）',
  your_physical_address: '您的实际地址，与您注册帐户时使用的地址匹配',
  must_be_a_utility_bill: '必须是水电费账单（电费，水费，电话费，煤气/能源费，市政税/卫生费单）或银行对帐单',
  for_further_info_attach: '**有关更多文档，请通过电子邮件将其附加并发送至backoffice@eurotrader.com',
  banners_ad_blocker_notice: '如果您在查看下面的横幅广告时遇到问题，请禁用您的广告拦截器',
  transfer_out: '转出',
  transfer_in: '转入',
  done: '完成',
  not_required: '不需要',
  wallet_balance: '钱包余额',
  must_agree_terms: '您必须同意我们的条款和条件才能创建帐户',
  select_payment_method: '选择支付方式',
  islamic_account: '穆斯林账户',
  islamic_documents_instructions: '清真寺的宗教证明',
  card_number: '卡号',
  expiry: '截至',
  redeem: '赎回',
  must_be_multiple_of_10: '数值必须为10整数倍',
  select_starting_balance: '选择开始余额',
  business_name: '公司名称',
  business_bank_wire_instructions: '公司电汇指南',

  error_request_failed: '错误：申请失败',
  error_no_user_with_this_email: '错误：此账户注册邮件地址不存在',
  error_too_many_password_reset_requests: '错误：过多密码重设申请',
  error_expired_or_invalid_request: '错误：无效或过期申请',
  error_insufficient_wallet_balance: '错误：钱包余额不足',
  error_insufficient_balance_or_equity: '错误：余额或净值不足',
  error_pamm_master_deposit: '不能入金至Pamm主账户',
  error_pamm_master_withdrawal: 'Pamm主账户不能出金',
  error_pamm_master_locked_deposits: '已拒绝：存款帐户的pamm主帐户会在未平仓交易期间拒绝入金。',
  error_pamm_master_locked_withdrawals: ' 已拒绝：从中提取资金的帐户的pamm主数据会拒绝未平仓交易中的出金',
  error_pamm_master_minimum_deposit: '已拒绝：未满足pamm管理员的最低存款要求。',
  error_live_account_already: '您的帐户已经是真实账户',
  error_min_balance_required_is: '账户余额最低要求{TAAccountType} 账户({TAID}) 是 {min}{currency}.',
  error_transfer_same_wallet: '不得钱包之间相互转账',
  error_transfer_same_trading_account: '不得同账户之间转账',
  upgrade_required_for_live_ta: '必须已开设真实和审核通过的客户帐户，才能开设真实交易帐户！',
  error_wallet_currency_not_allowed_for_psp: '钱包货币不支持此支付方式',
  error_invalid_or_expired_otp: '错误：已提供OTP无效或过期',
  error_max_confirmo_withdrawal_exceeded: '错误：最高单笔出金申请为20000欧元/美元',
  error_max_anual_vload_withdrawal_exceeded: '错误：超过了每年最大的vload提取请求总数',
  error_no_deposit_bonus_account_deposit_restricted: '',
  error_no_deposit_bonus_base_amount_withdrawal: '',
  error_no_deposit_bonus_withdraw_profit_requirement_not_met: '',
  error_no_deposit_bonus_withdraw_exceeds_max_withdrawable_profit: '',

  // Check for islamic trading account (temporarily disabled)
  is_islamic_acc_message: ' 为了创建一个伊斯兰帐户，请发送请求至backoffice@eurotrader.com，以便为您提供进一步的帮助',
  error_invalid_voucher: '错误：VLoad凭证无效或已被兑换',
  error_blocked_voucher: '错误：由于欺诈嫌疑，VLoad凭证被阻止',
  error_voucher_data_mismatch: '错误：由于帐户数据不匹配，VLoad凭证被拒绝',
  error_vload_voucher_below_minimum: ' 错误：Vload凭证低于最低存款额。',
  my_bank_has_a_swift_code: ' 我的银行有SWIFT国际清算代码。',
  my_bank_does_not_have_a_swift_code: '我的银行没有SWIFT国际清算代码',
  bank_not_in_swift_network_instructions: '如果您的银行不是SWIFT成员，请向我们提供您银行的代理行的以下详细信息，以便接收国际电汇',
  correspondent_bank_name: '代理行名称',
  correspondent_bank_city: '代理行城市',
  correspondent_bank_swift: '代理行国际清算代码',

  // New document upload strings
  proof_of_cc: '银行卡证明',
  front_of_cc: '银行卡正面',
  back_of_cc: '银行卡背面',
  proof_of_cc_instructions: '请上传您的银行卡图片',
  add_document: '添加文件（可选）',
  cc_requirements_1: '显示所有4个角的文档的完整副本。',
  cc_requirements_2: '持卡人姓名：您将要使用的卡只能以您的名字发行。使用属于第三方的卡进行的任何入金，都将立即退还。',
  cc_requirements_3: '截止日期：不得少于3个月。',
  cc_requirements_4: '卡号：卡的中间六个数字必须用一张纸覆盖。只有前6位和后4位必须可见。',
  cc_back_requirements_5: ' CVV代码：请用一张纸覆盖CVV代码。',
  cc_back_requirements_6: '该卡必须签名。',
  click_to_add_another_document: '单击上方以添加另一个文档上传功能',
  add_up_to_4_extra_documents: '您可以最多上传4份文件',
  add_up_to_10_extra_documents: '您可以最多上传10份文件',
  complete_profile: '完整个人资料',
  document_received: ' 您的文件已收到，我们的团队将对其进行审核。',
  please_check_the_box: ' 请选中下面的框。',
  must_be_over_18: ' 您必须年满18岁才能注册。',
  document_req_color: '文件必须为彩色',
  internal_error: ' 发生内部错误。',
  please_enter_your_email: ' 请输入您的电子邮件地址。',
  do_you_want_to_transform_your_trading: '您想改变您的交易吗？',
  reset_your_password_to_transfer_your_account: ' 重设密码以完成帐户转账。',
  reset_your_old_password: '重设您的旧密码',
  reset_password_desc: ' 由于系统传输，您需要更新密码。请使用以下表格接收重置密码链接。',
  eurotrader_login: 'Eurotrader 登录| 进入交易中心后台',
  your_email_is_verified: ' 您的电子邮件已经通过验证。',
  click_here_to_login: '点击这里登录',
  success_email_verified: '成功，您的电子邮件验证通过！',
  your_link_expired: '您的链接已失效',
  click_here_to_request_verification_email: '点击这里申请新的确认邮件。',
  a_new_verification_link_send: ' 新的验证链接已发送到您的电子邮件地址。',
  invalid_request_please_check_your_link: ' 无效的请求。请检查您的链接是否正确，然后重试。',
  invalid_verification_code: '无效验证码',
  please_enter_amount: '请输入您要存入的金额',
  bankwire_company_desc:
    '<p>如果您是公司银行帐户持有人，并且想通过向我们注册您的公司帐户来使用银行电汇选项，请通过电子邮件将以下文档发送给我们：backoffice@eurotrader.com</p><ul><li>公司注册文件</li><li>董事和秘书证书（如适用）</li><li> 注册股东证书/唯一所有者。</li><li>公司组织章程大纲和细则，也称为公司章程</li><li> 所有注册股东，实益所有者和董事的身份证明和地址证明。</li><li>与公司有关的地址证明。</li></ul><p>如果无法以上述格式提供上述文件，则需要提供任何其他验证上述要求信息的政府/官方文件。</p>',
  bankwire_noncompany_desc: '<p>这将从您的个人帐户中注销，并将您重定向到我们公司帐户的注册页面。</p><p>是否执行？</p>',
  please_enter_card_detail_and_amount: ' 请输入卡的详细信息和您希望入金的金额',
  important: '重要',
  please_note_that_the_maximum_deposit_amount: ' 请注意，每张卡每天的最高入金额为1000美元。',
  city: '城市',
  zip: '邮编',
  please_note_that_after_three_unsuccessful_attempts: ' *请注意，三（3）次失败尝试后，VISA / MASTERCARD付款选项将在24小时内不可用。',
  epay_pro_desc:
    '<p>尊敬的客户<br><br>不幸的是，由于某些技术问题和限制，我们将通过我们的提供商EPayPro暂时禁用信用卡入金方式。<br> <br> Visa和Mastercard将于格林尼治标准时间2018年4月4日午夜23:00禁用。付款提供商被禁用后，入金将被暂时禁用。尽管我们的入金提供商没有为我们提供确切的停机时间范围，但我们正在努力尽快实施替代方案。<br><br>我们正在与供应商合作解决当前问题，以便将来可以立即恢复处理帐户中的入金。<br> <br>如有任何其他问题，请随时与我们的客服团队联系。</ p>',
  provider_redirect: '您将被转至{provider}.',
  lydiax_note: '最低入金额30欧元/美元',
  lydiax_note1: '如果您存入的{crypto}的价值不足30欧元/美元，则需要发送电子邮件至backoffice@eurotrader.com，并要求退款，并提供您希望退款的{crypto}地址。',
  lydiax_note2: '请输入您希望入金的{crypto}金额，以查看对您的预期收益。请记住，以下价格仅在被要求时才有效，并且可以随时更改。',
  lydiax_note3: '我们将为您生成一个入金地址',
  lydiax_note4: '请使用下面的地址{crypto}。',
  lydiax_note5: '此后，此唯一地址将用于您在{crypto}中的存款。',
  lydiax_required_address: ' 如果您的钱包需要地址和标签分开使用',
  tag: '标签',
  lydiax_enter_deposit: '请输入您想入金采用的数字货币',
  create_address: '目前地址',
  please_note: '请注意',
  price_estimate: '价格估值',
  check_price: '查看价格',
  vload_please_enter_voucher: '请输入您的VLOAD密码',
  vload_minimum: ' <p>（可接受的最低凭证值为<b> 50 </ b>欧元或美元！）</ p>',
  vload_vouchers: ' 我需要购买Vload消费券',
  vload_note: '通过Visa / MasterCard以及银行电汇进行支付。<br />了解有关VLoad的更多信息，或在vload.expert上购买[EUR / USD]优惠券。',
  vload_note1: '为了能够使用VLoad进行入金，必须首先批准您的帐户！',
  reason: '原因',
  attempts: '已尝试 {attempts}最多  {maxAttempts},',
  two_more_remaining: '剩余两（2）次',
  one_more_remaining: '剩余只有一（1）次',
  please_contact_bank: ' <br />请与发卡银行联系。<br />您的卡可能无法进行海外交易',
  edata_success_note:
    ' 请注意，由于国际交易，发卡银行可能会向您的存款收取额外费用。这笔费用是一笔小额费用，但各家银行的费用会有所不同。 <br> <br>此信用卡交易将在您的对帐单上显示为" Tech Savvy Billing"，" Business Billing"或" Business media Billing"。',
  you_can_try: '您可以重新尝试',
  here: '这里',
  safe_charged_success_message: ' 您的存款将在2个工作日内由我们的团队处理。',
  thank_you: '谢谢您！',
  your_deposit_successful: '您的入金成功',
  card_redirect: ' 您将被重定向，请输入您的信用卡和个人详细信息',
  bank_wire_withdrawal_note:
    '如果由于客户提供的错误的银行详细信息而代表收款银行拒绝了银行电汇，则将从相关提款银行收取的各种银行电汇管理费用从所要求的取款额中扣除，然后才计入客户的钱包。',
  please_enter_amount_withdraw: '请输入您想出金的数额',
  bitcoin_note: '请输入您的比特币地址和您要提取的金额',
  otp: '一次性密码 (OTP)',
  otp_send_email: '发送OTP至电子邮件',
  otp_additional_text: ' 上面的OTP是针对您当前提出的比特币提款请求',
  otp_new_password: ' 新的一次性密码（OTP）已发送到您的电子邮件',
  otp_error: ' 错误-无法发送OTP',
  lydiax_withdrawal_note: '请输入您要提取的{currency}金额，以查看估计的{crypto}。请记住，以下价格仅在被要求时才有效，并且可以随时更改。',
  enter_currency_amount: ' 输入{currency}金额以检查估算值',
  lydiax_withdrawal_additional_note: ' 上面的OTP是针对您当前提出的加密货币提款请求',
  estimated: '估值',
  please_enter_your_crypto_address: ' 请输入您的{crypto}地址和您要提取的金额',
  select_cryptocurrency: '选择加密货币',
  request_amount: '已申请数值',
  amount_changes: ' 收取的金额（包括费用）',
  operation_failed: '操作失败！您的要求无效。',
  operation_failed_error: ' 操作失败！处理此请求时出错。',
  are_you_sure_create_master: '您确定要创建一个新帐户并将其附加到该主帐户下吗？',
  are_you_sure_attach_selected_account_to_master: ' 您确定要将所选帐户附加到该主帐户吗？',
  change_password_desc:
    ' <strong> * </ strong>此密码更改不会影响您的交易帐户密码。请使用图标下方的<strong>更改密码</ strong>选项，访问<strong>帐户列表</ strong>以更改您的交易帐户密码。',
  client_assessment: '客户评估',
  select_answer: '选择答案…',
  declarations: '声明',
  complele_profile_desc: '您目前或曾经参与任何犯罪活动，或者有未决刑事指控要对您提起诉讼吗',
  complete_profile_desc1:
    '您或您的亲戚或近亲是政治人物吗？政治人物是指过去12个月内或曾经被赋予重要公共职能的自然人，即国家元首或政府首脑，高级政治人物，高级政府，司法或军事官员，国有公司的高级管理人员，重要的政党官员。',
  are_you_us_citizen: '您是有税收责任的美国公民还是美国居民？',
  please_check_forms_errors: '请检查表格中是否有错误！',
  profile_succesfully_completed: ' 个人资料已成功完成',
  please_select_country: '请选择您的国家',
  set_country: '选择国家',
  empty_country_code: ' 国家代码为空，请刷新页面，然后重试。',
  invalid_country_code: '国家/地区代码无效，请刷新页面，然后重试。',
  individual_company: ' 您是个人还是公司？',
  prev: 'PREV',
  previous: '之前',
  complete: '完成',
  please_select_an_option: '请在填空处做出选择！',
  swap: '交换',
  buy: '买入',
  sell: '卖出',
  sums: '合计',
  net_total: '净值总数',
  deposit_page_desc:
    ' <p class =" has-text-white is-size-5-desktop is-size-6-tablet is-size-6-mobile has-text-weight-bold">立即注册并</ p> <p class =" is-size-1-desktop is-size-2-tablet is-size-3-mobile has-text-weight-bold vload-promo-large-text">获取一个<span class =" has-text -white has-text-weight-bold">免费</ span> <br/> 10欧元/美元<br/>电子优惠券</ p>',
  deposit_page_desc1: ' 您一旦激活10 EUR / USD电子优惠券，',
  create_new_account: '创建新账户',
  successfully_purchase_vload: ' 成功购买和赎回任何价值的VLoad 电子优惠券',
  upgrade_to_tier_2: '升级至第二等级',
  register_now: '现在注册',
  back: '退回',
  my_card_desc: '在这里，您可以查看所有用于支付的卡及其在我们系统中的当前状态。',
  you_have_no_card: '您目前无任何银行卡入金。',
  card_no: '银行卡号.',
  last_used: '上次使用',
  risk_warning: '风险警告',
  upload_documents_note: '如果您想保存入金银行卡，请另外提供以下文件，以供检查和批准。',
  please_select_your_country: '请选择您的国家',
  add_another_document: '添加另外的文件',
  drop_files_upload: '将文件放置此处上传',
  date_until: '截止日期',
  copy: '复制',
  cvv: 'CVV',
  please_enter_crypto_amount: '输入{crypto} 数额',
  vload_pin: 'Vload密码',
  deposit_info: '付款提供商当前遇到技术问题，目前无法使用Visa / Mastercard直接入金。另外，如果您想使用Visa / Mastercard入金，则可以使用" Vload"选项',
  id: 'ID',
  pamm_modal_error: '显示名称输入无效。请不要留空或输入超过32个字符',
  pamm_modal_error1: ' 输入的最低存款金额无效。请输入一个小于1,000,000的正整数。',
  error_missing_required_field: ' 错误，缺少必填字段',
  page_not_found: '网页未找到',
  new_version_note: '检测到新版本，请点击此处刷新',
  new_version_note1: '在刷新页面之前，某些功能可能不可用',
  records: '记录',
  gateway: '接口',

  // Demo Account
  train_up: '练习起来',
  trade_up: '交易起来',
  train_text_1: '准备好投资未来得自己？',
  train_text_2: ' 开始使用无风险的模拟帐户，并访问Eurotrader学院的学习资源。',
  train_list_item_1: ' 在模拟环境中练习交易。',
  train_list_item_2: ' 获得一流的学习资源。',
  train_list_item_3: ' 成为Eurotrader社区的一部分。',
  train_list_item_4: ' 记住：没有什么可以失去，一切都可以得到。',
  form_title_1: '开始使用',
  form_title_2: '您的',
  form_title_3: '模拟账户',
  form_subtitle: ' 并获得学习资源',
  region: '地区',
  wallet_currency: '钱包货币',
  select_currency_label: '模拟账户货币',
  join: '加入',
  demo_account: '模拟账户',
  page_title_demo: '开设模拟账户 | Eurotrader',

  // 404 Page
  title_404: 'Hi 外汇，我来了！',
  text_line_1_404: ' 什么？这里没有人可以帮助您投资自己的未来吗？',
  text_line_2_404: '让我们开始学习盈利',
  button_404: '回去',

  remember_me: '记住我',
  risk_sentence: '了解我们怎样使用您的资料信息，请查看',
  video_courses: '视频课程',
  ebooks: '电子书籍',

  // Complete Profile
  knowledge_and_experience: '知识与经验',
  economic_profile: '经济状况',
  product_governance: '产品管控',
  select_an_answer: '选择答案',
  declarations_q1: '您目前或曾经参与任何犯罪活动，或者有未决的刑事指控要在法院审理吗？',
  declarations_q2:
    '您或您的亲戚或近亲是政治人物吗？政治人物是指过去12个月内或曾经被赋予重要公共职能的自然人，即国家元首或政府首脑，高级政客，高级政府，司法或军事官员，国有公司的高级管理人员，重要的政党官员。',
  declarations_q3: '您是有税收义务的美国公民或是美国居民？',

  ca_q1: '1. 您有任何交易经验？',
  ca_q2: ' 2.您在金融市场投资/交易了多长时间？',
  ca_q3: '3.在过去两年中，您执行了几笔交易？ <br>&nbsp;&nbsp; a.股票和固定收益产品（股票和债券）',
  ca_q4: '&nbsp;&nbsp; b. 外汇',
  ca_q5: '&nbsp;&nbsp; c. CFDs (差价合约产品)',
  ca_q6: '&nbsp;&nbsp; d. 其他衍生产品（担保，期权等产品）',
  ca_q7: ' 4.您投资到以下类别的平均金额（每月）是多少？ <br>&nbsp;&nbsp; a.股票和固定收益产品（股票和债券）',
  ca_q8: '&nbsp;&nbsp; b. 外汇',
  ca_q9: '&nbsp;&nbsp; c. CFDs (差价合约产品)',
  ca_q10: '&nbsp;&nbsp; d. 其他衍生产品（担保，期权等产品）',
  ca_q11: '5.您已经使用了哪种类型的投资服务？ （包含多项选择）',
  ca_q12: '6.以下任何一项对您适用吗？ （包含多项选择)',
  ca_q13:
    ' 7.苹果股票的交易卖出价格为204美元，买入价格为206美元。您以上述价格购买了100股苹果股票。如果苹果股票的价格以190美元的卖出价格和192美元的买入价移动，您的帐户会产生什么盈亏？',
  ca_q14:
    '8.苹果股票的交易价格为204美元的卖出价和206美元的买入价。您进行买入（做多）CFD交易，交易了100张合约（每张合约等价于1股苹果的合约）。使用的杠杆为1：5。如果苹果股票的价格以190美元的卖出价格和192美元的买入价移动，您的帐户会产生什么盈亏？',
  ca_q15: '9.使用止损单：',
  ca_q16: '10.您的帐户余额不足。在哪种情况下，您可能需要向帐户中添加资金？',
  ca_q17:
    '11.标普500指数的买入价为2700美元。您决定开立2个合约的多头（买入）差价合约交易。使用的杠杆为1:20。您以2600美元的价格设置止损，并以3000美元的价格设置获利。假设您的帐户上的余额足够，并且订单保持不变，直到达到止损卖出价格或止盈卖出价格并且没有产生任何额外费用，那么当您在帐户上产生的损益是多少仓位会进行平仓？',
  ca_q18: '1.您的年度总收入是多少？',
  ca_q19: '2.您的收入来源是什么？',
  ca_q20: '3.您年收入中有多少比重承担财务亏欠责任？',
  ca_q21: '4.您的资产的估计价值是多少？',
  ca_q22: '5.您的资产的结构是什么？',
  ca_q23: '6.您估计的净值是多少（总资产–总负债）？',
  ca_q24: '1.请选择以下陈述之一：',
  ca_q25: '2.以下哪种说法更适合您？',
  ca_q26: '3.与您的投资方式最相关的是什么？',
  ca_q27: '4.根据您的期望，您愿意接受的投资组合价值的年度波动是多少？',
  ca_q28: '5.以下哪个选项将被认为是最适合您的投资组合',
  ca_q29: '6.您的投资目标的时间范围是什么？',
  ca_q30: '7.您的投资目标是什么？',
  ca_q31: '8.您愿意接受的投资组合的流动性水平是多少？',

  ca_q1_ao1: 'a）是的，我已经进行了真实账户交易',
  ca_q1_ao2: 'b）是的，我已经在模拟账户上交易',
  ca_q1_ao3: 'c）否，但我使用过投资组合管理和/或投资建议的投资服务',
  ca_q1_ao4: 'd）否，但是我通过我的教育获得了充足的知识（学士学位，硕士学位等）',
  ca_q1_ao5: 'e) 否',
  ca_q2_ao6: 'a) 0 - 6 个月',
  ca_q2_ao7: 'b) 6 - 12 个月',
  ca_q2_ao8: 'c) 1 - 2 年',
  ca_q2_ao9: 'd) 2 - 4 年',
  ca_q2_ao10: 'e) 超过4年',
  ca_q3_ao11: 'I. 永不',
  ca_q3_ao12: 'II. 很少（少于50次）',
  ca_q3_ao13: 'III. 有时（50-100次）',
  ca_q3_ao14: 'IV. 经常（超过101次交易）',
  ca_q4_ao15: 'I. 永不',
  ca_q4_ao16: 'II. 很少（少于50次）',
  ca_q4_ao17: 'III. 有时（50-100次）',
  ca_q4_ao18: 'IV. 经常（超过101次交易）',
  ca_q5_ao19: 'I. 永不',
  ca_q5_ao20: 'II. 很少（少于50次）',
  ca_q5_ao21: 'III. 有时（50-100次）',
  ca_q5_ao22: 'IV. 经常（超过101次交易）',
  ca_q6_ao23: 'I. 永不',
  ca_q6_ao24: 'II. 很少（少于50次）',
  ca_q6_ao25: 'III. 有时（50-100次）',
  ca_q6_ao26: 'IV. 经常（超过101次交易）',
  ca_q7_ao27: 'I. 0',
  ca_q7_ao28: 'ii. 少于500欧元',
  ca_q7_ao29: 'iii. 501 - 2,000欧元',
  ca_q7_ao30: 'iv. 2,001 - 5,000欧元',
  ca_q7_ao31: 'v. 超过5,001欧元',
  ca_q8_ao32: 'I. 0',
  ca_q8_ao33: 'ii. 少于500欧元',
  ca_q8_ao34: 'iii. 501 - 2,000欧元',
  ca_q8_ao35: 'iv. 2,001 - 5,000欧元',
  ca_q8_ao36: 'v. 超过5,001欧元',
  ca_q9_ao37: 'I. 0',
  ca_q9_ao38: 'ii. 少于500欧元',
  ca_q9_ao39: 'iii. 501 - 2,000欧元',
  ca_q9_ao40: 'iv. 2,001 - 5,000欧元',
  ca_q9_ao41: 'v. 超过5,001欧元',
  ca_q10_ao42: 'I. 0',
  ca_q10_ao43: 'ii. 少于500欧元',
  ca_q10_ao44: 'iii. 501 - 2,000欧元',
  ca_q10_ao45: 'iv. 2,001 - 5,000欧元',
  ca_q10_ao46: 'v. 超过5,001欧元',
  ca_q11_ao47: 'a. 交易的接收和传送和/或执行（需要独立决定的投资服务）',
  ca_q11_ao48: 'b. 投资建议',
  ca_q11_ao49: 'c. 投资组合管理',
  ca_q11_ao50: 'd. 无',
  ca_q12_ao51: 'a. 我有相关专业经验',
  ca_q12_ao52: 'b. 我经常观察市场信息',
  ca_q12_ao53: 'c. 我参加了关于金融市场/投资/线上交易相关的课程或讨论会',
  ca_q12_ao54: 'd. 以上都不是',
  ca_q13_ao55: 'a. -1,200欧元',
  ca_q13_ao56: 'b. -1,400欧元',
  ca_q13_ao57: 'c. -1,600欧元',
  ca_q13_ao58: 'd. -1,800欧元',
  ca_q14_ao59: 'a. -6,000欧元',
  ca_q14_ao60: 'b. -7,000欧元',
  ca_q14_ao61: 'c. -8,000欧元',
  ca_q14_ao62: 'd. -10,000欧元',
  ca_q15_ao63: 'a. 保护您免受快速损失的困扰',
  ca_q15_ao64: 'b. 限制您的风险敞口',
  ca_q15_ao65: 'c. 确保您永远不会亏损',
  ca_q15_ao66: 'd. 保护您免受使用杠杆的风险',
  ca_q16_ao67: 'a. 如果未平仓合约的价格对您不利，以使您的资产跌至最低维持保证金以下.',
  ca_q16_ao68: 'b. 如果您产生交易费用，这会使您的帐户处于亏损状态。',
  ca_q16_ao69: 'c. 如果未平仓的差价合约头寸产生隔夜费用，这会使您的帐户处于亏损状态',
  ca_q16_ao70: 'd. 以上全是',
  ca_q17_ao71: 'a. -$100 或 $300',
  ca_q17_ao72: 'b. -$200 或 $600',
  ca_q17_ao73: 'c. -$2,000 或 $6,000',
  ca_q17_ao74: 'd. -$4,000 或 $12,000',
  ca_q18_ao75: 'a. 少于20,000欧元',
  ca_q18_ao76: 'b. 20,000欧元与50,000欧元之间',
  ca_q18_ao77: 'c.  50,000欧元与100,000欧元之间',
  ca_q18_ao78: 'd. 高于100,000欧元',
  ca_q19_ao79: 'a. 工资/养老金',
  ca_q19_ao80: 'b. 股息/利息/息票',
  ca_q19_ao81: 'c. 租金',
  ca_q19_ao82: 'd. 捐赠/ 继承',
  ca_q19_ao83: 'e. 其他收入来源',
  ca_q20_ao84: 'a. 少于25%',
  ca_q20_ao85: 'b. 25% 与 50%之间',
  ca_q20_ao86: 'c. 50% 与 75%之间',
  ca_q20_ao87: 'd. 高于75%',
  ca_q21_ao88: 'a. 少于100,000欧元',
  ca_q21_ao89: 'b. 100,000 与 500,000欧元之间',
  ca_q21_ao90: 'c. 500,000 与 1,000,000欧元之间',
  ca_q21_ao91: 'd. 高于1,000,000欧元',
  ca_q22_ao92: 'a. 以银行存款为主',
  ca_q22_ao93: 'b. 以房产为主',
  ca_q22_ao94: 'c. 以金融产品为主',
  ca_q22_ao95: 'd. 上述选择平均分配持有',
  ca_q22_ao96: 'e. 其它',
  ca_q23_ao97: 'a. 少于100,000欧元',
  ca_q23_ao98: 'b. 100,000 与 500,000欧元之间',
  ca_q23_ao99: 'c. 500,000 与 1,000,000欧元之间',
  ca_q23_ao100: 'd. 高于1,000,000欧元',
  ca_q24_ao101: 'a. 我只承担可能在极端情况下减少我的投资本金的风险。',
  ca_q24_ao102: 'b. 为了达到高于平均回报的水平，我可以冒险投资一部分资金。',
  ca_q24_ao103: 'c. 我可以冒部分或全部投资本金的风险，希望能获得更高的回报。',
  ca_q25_ao104: 'a.对我来说最重要的是我的资金安全。因此，为了避免任何损失，我准备放弃更高的回报。',
  ca_q25_ao105: 'b.为了获得高于平均水平的回报，我接受更高的风险，并准备接受我的资金略有减少。',
  ca_q25_ao106: 'c.为了获得高回报，即使我的一部分或全部资金有风险，我也愿意承担高风险。',
  ca_q26_ao107: 'a. 资本保全',
  ca_q26_ao108: 'b. 收入增长',
  ca_q26_ao109: 'c. 投机',
  ca_q26_ao110: 'd. 对冲',
  ca_q27_ao111: 'a. ± 5%',
  ca_q27_ao112: 'b. ± 10%',
  ca_q27_ao113: 'c. ± 25%',
  ca_q27_ao114: 'd. ± 50%',
  ca_q28_ao115: 'a. 未来几年将产生稳定的1-2％回报率的股票。',
  ca_q28_ao116: 'b. 未来几年将产生-2％至+ 10％的回报。',
  ca_q28_ao117: 'c. 预计明年将产生-15％至+ 30％的回报，在极端情况下甚至可能导致损失超过投资额。',
  ca_q29_ao118: 'a. 最高一年',
  ca_q29_ao119: 'b. 1年与3年之间',
  ca_q29_ao120: 'c. 3年与5年之间',
  ca_q29_ao121: 'd. 超过5年',
  ca_q30_ao122: 'a. 短期流动资金管理，以支付意外费用。',
  ca_q30_ao123: 'b. 长期节省',
  ca_q30_ao124: 'c. 即使冒着损失投资额的风险也能赚取高额利润',
  ca_q31_ao125: 'a. 低于25%',
  ca_q31_ao126: 'b. 25% 与 50%之间',
  ca_q31_ao127: 'c. 50% 与 75%之间',
  ca_q31_ao128: 'd. 高于75%',

  passport_ple_different: '如果您的居住国家和身份证的签发国家不同，请上传您的护照。',

  live_account: '真实账户',
  agree_terms_marketing: '我同意接收来自Eurotrader的市场动态新闻 (查看 <a href="{PRIVACY_URL}" target="_blank">隐私条款</a> )',
  data_policy_text:
    '您的个人信息是安全的,并且您可以随时取消订阅。点击下面链接，您确定阅读并接受  <a href="{TERMS_CONDITIONS_URL}" target="_blank">条例条款</a> 以及 <a href="{RISK_DISCLOSURE_URL}" target="_blank"> 风险提示 </a> 并且您确认我们将储存并处理使用您的个人信息。',
}



// WEBPACK FOOTER //
// ./src/locale/zh.js